import {
  addClientByClient,
  addClientData,
  getClientDataByClient,
  getClientIdData,
  getClientSearch,
  getClientsData,
  rolesForClient,
  searchClientData,
  setPageNumber,
  setRowsPerPage,
  updateClientData,
} from "../../store/clients";
import useEntityList from "./useEntityList";

const CLIENT_ACTIONS = {
  getClientsDataAction: getClientsData,
  searchClientDataAction: searchClientData,
  clientSearchByClient: getClientSearch,
  addClientDataAction: addClientData,
  updateClientDataAction: updateClientData,
  setRowsPerPageAction: setRowsPerPage,
  setPageNumberAction: setPageNumber,
  getClientIdDataAction: getClientIdData,
  addClientByClientAction: addClientByClient,
  getClientDataByClientAction: getClientDataByClient,
  rolesClientAction: rolesForClient,
};

const selectClientExtras = (clients) => ({
  clientId: clients?.clientId ?? null,
});

function useClients() {
  return useEntityList({
    stateKey: "clients",
    listKey: "clientList",
    actionCreators: CLIENT_ACTIONS,
    selectExtras: selectClientExtras,
  });
}

export default useClients;
